import React from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const Layout = ({ children }) => {
  return (
    <div className="App flex flex-col min-h-screen">
      <Header />
      <main className="flex-1 pt-[70px]">{children}</main>
      <Footer />
    </div>
  );
};

export const PageHeader = ({ title, subtitle, testId }) => (
  <section data-testid={testId} className="sunburst-bg text-white py-16 sm:py-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center fade-up">
      <h1 className="font-display text-4xl sm:text-5xl mb-3">{title}</h1>
      <div className="w-24 h-1 bg-amber-500 mx-auto rounded-full mb-4" />
      {subtitle && <p className="text-slate-300 max-w-2xl mx-auto text-base sm:text-lg">{subtitle}</p>}
    </div>
  </section>
);

export const EmptyState = ({ icon = "inbox", message }) => (
  <div className="text-center py-20 text-slate-400">
    <i className={`fa-solid fa-${icon} text-5xl mb-4 text-amber-300`} />
    <p className="text-lg">{message}</p>
  </div>
);

export const SectionTitle = ({ children, sub }) => (
  <div className="mb-10 text-center">
    <h2 className="font-display text-3xl sm:text-4xl text-[#0a2540]">{children}</h2>
    <div className="w-20 h-1 bg-amber-500 mx-auto rounded-full mt-3" />
    {sub && <p className="text-slate-500 mt-3 max-w-2xl mx-auto">{sub}</p>}
  </div>
);
